import { render, staticRenderFns } from "./163.vue?vue&type=template&id=fca54b7e&scoped=true&"
var script = {}
import style0 from "./163.vue?vue&type=style&index=0&id=fca54b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca54b7e",
  null
  
)

export default component.exports